module.exports = __webpack_public_path__ + "static/media/bg-hero-01-mobile.76700601.png";